import Layout from '@/layout'

const financeRouter = {
  path: '/finance',
  component: Layout,
  redirect: '/finance/finance-list',
  name: 'Finance',
  meta: {
    title: '资金管理',
    icon: 'money'
  },
  children: [
    {
      path: 'finance-list',
      component: () => import('@/views/finance/finance-list'),
      name: 'FinanceList',
      meta: { title: '资金列表' }
    },
    {
      path: 'finance-edit',
      component: () => import('@/views/finance/finance-edit'),
      name: 'FinanceCreate',
      meta: { title: '新增资金', activeMenu: '/finance/finance-list' },
      hidden: true
    },
    {
      path: 'finance-edit/:id',
      component: () => import('@/views/finance/finance-edit'),
      name: 'FinanceEdit',
      meta: { title: '编辑资金', activeMenu: '/finance/finance-list' },
      hidden: true
    },
    {
      path: 'finance-detail/:id',
      component: () => import('@/views/finance/finance-preview'),
      name: 'FinanceDetail',
      meta: { title: '资金详情', activeMenu: '/finance/finance-list' },
      hidden: true
    },
    {
      path: 'ledger-flows/:id',
      component: () => import('@/views/finance/ledger-flows'),
      name: 'LedgerFlows',
      meta: { title: '台账流水', activeMenu: '/finance/finance-list' },
      hidden: true
    },
    {
      path: 'interest-calculation',
      component: () => import('@/views/finance/interest-management-list'),
      name: 'InterestCalculation',
      meta: { title: '利息计算' }
    },
    {
      path: 'interest-management',
      redirect: '/finance/interest-calculation',
      name: 'InterestManagementLegacy',
      meta: { title: '利息计算', hidden: true }
    },
    {
      path: 'interest-calculation-create',
      component: () => import('@/views/finance/interest-calculation-create'),
      name: 'InterestCalculationCreate',
      meta: { title: '新增利息计算', activeMenu: '/finance/interest-calculation' },
      hidden: true
    },
    {
      path: 'interest-calculation-detail/:id',
      component: () => import('@/views/finance/interest-calculation-detail'),
      name: 'InterestCalculationDetail',
      meta: { title: '利息记录查看', activeMenu: '/finance/interest-calculation' },
      hidden: true
    },
    {
      path: 'payment-detail/:id',
      component: () => import('@/views/finance/payment-detail'),
      name: 'PaymentDetail',
      meta: { title: '收付款明细', activeMenu: '/finance/interest-calculation' },
      hidden: true
    }
  ]
}

export default financeRouter 